/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const DIRECT_UPLOAD_MUTATION = gql`
  mutation tenantDirectUpload( $file: [TenantDirectUploadCreateInput!] ) {
    tenant {
      directUpload( create: $file ) {
        metadata {
          url
          headers
          blobId
          signedBlobId
        }
        errors
      }
    }
  }
`;
